<template>
  <div>
    <page-header
      :back="selectedObject !== null"
      :onRoute="() => handleObjectClick(null)"
      :title="'Edit Objects'"
      :commands="!selectedObject ? [{
        click: () => handleObjectClick('NEW'),
        icon: '+',
        text: 'New object'
      }] : []"
    />
    <div class='container'>
      <h4 v-if="!selectedObject"> Select object to edit, or create a new one</h4>
      <div class='row c-v mb-20 pb-10 mt-20' v-else>
        <div>
          <h4 class='p-0 m-0 mb-10'>Object name</h4>
          <input
            class='form-field m-0'
            type='text'
            :value="selectedTitle"
            @input="e => updateField('selectedTitle', e.target.value)"
          >
        </div>
        <div class='ml-20'>
          <h4 class='p-0 m-0 mb-10'>Category</h4>
          <my-inputs
            type="select"
            :value="selectedCategory"
            name="selectedCategory"
            :handleChange="updateField"
            :options="[{ d: 'New Category', v: '__newCategory' }, ...objectCategories
              .map(v =>
                ({
                  d: v === '__noCategory' ? 'No Category' : v,
                  v: v,
                }))]"
          />
        </div>
         <div v-if="selectedCategory === '__newCategory'">
          <h4 class='p-0 m-0 mb-10'>New category name</h4>
          <input
            class='form-field m-0'
            type='text'
            :value="newCategoryName"
            @input="e => updateField('newCategoryName', e.target.value)"
          >
        </div>
      </div>
      <render-object-container
        :rootObject="selectedObject"
        v-if="selectedObject"
        :handleSaveClick="handleSaveClick"
        :handleDelete="handleDelete"
        :selectedId="selectedId"
      />
      <div v-else>
        <div
          class='card'
          v-for="category in objectCategories"
          :key="category"
          :style="{
            display: !categories[category] || categories[category].length < 1
              ? 'none' : 'block'
          }"
        >
          <h4 class='card-title'>
            {{ category === '__noCategory' ? 'No category' : category }}
          </h4>
          <div class='row container wrap'>
            <div
              class='card-box'
              v-for="(obj, index) in categories[category]"
              :key="obj.id"
              @click="() => handleObjectClick(index, obj.id)"
            >
              {{ obj.title }}
            </div>
          </div>
          <div class='container p-15 pb-20'>
            <copy-card
              v-if="category !== '__noCategory'"
              :label="`Get category ${category}`"
              class='mt-10'
              :text="`${objectLink}/${category}/`"
            />
          </div>
        </div>
      </div>
      <div class='mt-10 pt-10'> 
        <copy-card
          :label="'Objects list all'"
          :text="objectLink"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RenderObjectContainer from "../../components/RenderObjectStructure/index.vue";
import PageHeader from '../../components/PageHeader.vue';
import CopyCard from '@/myComponents/CopyCard.vue';
import MyInputs from '@/myComponents/MyInputs.vue';
import { api } from '../../services/api'
import TextComponent from "../../components/TextComponent.vue";

export default {
  name: "routeobjectmanager",
  components: { RenderObjectContainer, PageHeader, CopyCard, MyInputs },
  data: () => ({
    selectedObject: null,
    selectedTitle: null,
    selectedCategory: null,
    selectedId: null,
    newCategoryName: null
  }),
  async mounted () {
    if (!this.$store.getters.objects.loaded) {
      await this.$store.dispatch('loadObjects')
    }
    const paramId = this.$route.params.objectid
    if (paramId) {
      this.handleObjectClick(paramId, paramId)
    }
  },
  methods: {
    handleDelete () {
      this.$store.commit("setModal", {
        component: TextComponent,
        mounted: true,
        header: "Confirm delete",
        props: {
          text:
            `Are you sure you want to delete object ${this.selectedTitle}?`
        },
        goodClick: () => {
          this.$store.dispatch("deleteObject", this.selectedId);
          this.handleObjectClick(null)
        },
      });
    },
    handleObjectClick (index, id) {
      this.selectedObject = null
      this.selectedTitle = null
      this.selectedCategory = null
      this.newCategoryName = null
      this.selectedId = null
      if (index === 'NEW') {
        this.selectedObject = 'NEW'
        this.selectedTitle = "New Object"
        this.selectedCategory = "__noCategory"
      } else if (index !== null) {
        const findObj = this.objects.find(o => o.id + '' === id + '')
        if (findObj) {
          this.selectedObject = JSON.parse(findObj.object)
          this.selectedTitle = findObj.title
          this.selectedCategory = findObj.category || "__noCategory"
          this.selectedId = id
        }
      }
    },
    createObjectObject (id, object) {
      const obj = {
        id,
        title: this.selectedTitle,
        category: this.newCategoryName || this.selectedCategory,
        object: JSON.stringify(object)
      }
      if (
        obj.category === null ||
        obj.category.replace(/ /g, '') === '' ||
        obj.category === '__newCategory' ||
        obj.category === '__noCategory'
      ) {
        obj.category = null
      }
      return obj
    },
    async handleSaveClick (object) {
      if (this.selectedId) {
        const updatedObject = this.createObjectObject(this.selectedId, object)
        await this.$store.dispatch('updateObject', updatedObject)
      } else {
        await this.$store.dispatch(
          'addObject',
          this.createObjectObject(Date.now(), object)
        )
      }
      this.handleObjectClick(null)
    },
    updateField (param, value) {
      this[param] = value
    }
  },
  computed: {
    objectCategories () {
      return [
        '__noCategory',
        ...Object.keys(this.categories).filter(c => c !== '__noCategory').sort()
      ]
    },
    categories () {
      return this.objects.reduce((prev, curr) => {
        const cat = curr.category || '__noCategory'
        if (!prev[cat]) prev[cat] = [] 
        prev[cat].push(curr)
        return prev
      }, {})
    },
    objectLink () {
      const id = this.$store.getters.user && this.$store.getters.user.resourceid
      return `${api}/site/resources/objects-list/${id || ''}`
    },
    objects () {
      return this.$store.getters.objects.data
    }
  }
};
</script>
